// import * as React from 'react';
import styled from 'styled-components';

type Props = {
  label: string;
  value?: number;
};

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const Circle = styled.div`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.tertiary};
  padding: ${props => props.theme.space[1]}px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
`;

const StatCircle = (props: Props) => (
  <Wrapper>
    <Circle>{props.value ? props.value : '-'}</Circle>
    {props.label}
  </Wrapper>
);

export default StatCircle;
